import React, { useState } from 'react';

import { required } from '../../../../utils/form-validation';
import {
    Select,
} from '../../../Form';
import Popup from '../../../Popup';
import InfoButton from '../../../InfoButton';
import links from '../../../../../config/links';

const SelectIsConference = (props) => {
    const {
        field,
        value,
        formApi,
        onChange,
        disabled,
    } = props;

    const [showIsConferenceYesPopup, setShowIsConferenceYesPopup] = useState(false);
    const [showIsConferenceNoPopup, setShowIsConferenceNoPopup] = useState(false);

    const isConferenceSelected = (val) => {
        if (val === '1') {
            setShowIsConferenceNoPopup(true);
        } else if (val === '2') {
            setShowIsConferenceYesPopup(true);
        }
    };

    return (
        <>
            <div className={`d-flex align-items-start mt24`}>
                <div className={`flex-2`}>
                    <div className={`form-group form-group-xl mb0`}>
                        <label htmlFor={'verified'}>
                            {`Should this ${formApi.values.eventType === 13 ? 'team' : 'dual'} match be grouped in your standings?`}
                            <InfoButton
                                hoverText={(
                                    <>
                                        This enables coaches to group your conference/league together and have team records.
                                        High School team pages will include your conference/league on team pages with team records.
                                        <a href={links.hsStandingsArticle} target="_blank" rel="noopener noreferrer" data-testid="event-edit.conference.learn-more-link">
                                            &nbsp;Learn More
                                        </a>
                                    </>
                                )}
                            />
                        </label>
                    </div>
                </div>
                <div className={`flex-1`}>
                    <Select
                        id="isConference"
                        formGroupCssClass={`mb0`}
                        field={field}
                        value={value}
                        options={[
                            {
                                id: '1',
                                value: '1',
                                label: 'No',
                            },
                            {
                                id: '2',
                                value: '2',
                                label: 'Yes',
                            },
                        ]}
                        onChange={(val) => {
                            isConferenceSelected(val);
                            if (onChange) {
                                onChange(val);
                            }
                        }}
                        validate={required}
                        hiddenLabel={true}
                        disabled={disabled}
                    />
                </div>
            </div>
            {showIsConferenceYesPopup && (
                <Popup
                    className="popup-sm"
                    onCloseClick={() => {
                        setShowIsConferenceYesPopup(false);
                    }}
                    config={{
                        fullScreen: false,
                        noPadding: true,
                        style: {
                            height: '350px',
                        },
                    }}
                >
                    <div className="popup-section p24 pt0 pb0">
                        <h6 className="text-dark mb0">Included in Standings</h6>
                    </div>
                    <div className="popup-section p24">
                        <p>
                            By answering YES, both teams will be grouped together in standings on your team page.
                            If this team should not be included in your standings, answer NO and the dual match will only affect your overall record.
                        </p>
                        <div className="mt24">
                            <div className="row">
                                <div className="col-12">
                                    <button
                                        type="button"
                                        className="btn btn-default btn-default text-uppercase btn-block"
                                        onClick={() => {
                                            setShowIsConferenceYesPopup(false);
                                        }}
                                        data-testid="event-edit.conference-yes-popup.got-it-btn"
                                    >
                                        Got it
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Popup>
            )}
            {showIsConferenceNoPopup && (
                <Popup
                    className="popup-sm"
                    onCloseClick={() => {
                        setShowIsConferenceNoPopup(false);
                    }}
                    config={{
                        fullScreen: false,
                        noPadding: true,
                        style: {
                            height: '350px',
                        },
                    }}
                >
                    <div className="popup-section p24 pt0 pb0">
                        <h6 className="text-dark mb0">Not included in Standings</h6>
                    </div>
                    <div className="popup-section p24">
                        <p>
                            By answering NO, teams will NOT be grouped together within the standings section on your team page and the dual match will only affect your overall record.
                            If both teams should be grouped together in the standings, answer YES.
                        </p>
                        <div className="mt24">
                            <div className="row">
                                <div className="col-12">
                                    <button
                                        type="button"
                                        className="btn btn-default btn-default text-uppercase btn-block"
                                        onClick={() => {
                                            setShowIsConferenceNoPopup(false);
                                        }}
                                        data-testid="event-edit.conference-no-popup.got-it-btn"
                                    >
                                        Got it
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Popup>
            )}
        </>
    );
};

export default SelectIsConference;
